import React from 'react'
import LiteYouTubeEmbed from 'react-lite-youtube-embed'
import { OutboundLink } from 'gatsby-plugin-gtag'
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css'

import {
  EuiCard,
  EuiFlexGroup,
  EuiFlexItem,
  EuiText,
  EuiIcon
} from '@elastic/eui'


export default function softwareVideos() {

  return (
    <React.Fragment>
        <EuiFlexGroup gutterSize="l" direction="row" style={{margin: '0 7px'}} >
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <LiteYouTubeEmbed 
                    id="AV2vr5X7Re8"
                    title="Firmware überschreiben"
                    adNetwork={true}
                    poster="maxresdefault" //hqdefault
                    noCookie={true}
                />
              }
              footer={
                <EuiText>
                <p>In diesem Video zeigen wir Ihnen wie Sie über die serielle Schnittstelle Ihre INSTAR HD IP Kamera wiederbeleben können sofern Sie ein fehlerhaftes Firmwareupdate hatten weil z.B. die Stromverbindung unterbrochen wurde.</p>
                <p>Im Video zeigen wir Schritt für Schritt wie Sie die vorhandene Firmware durch die aktuelle überspielen können. Auf <OutboundLink href="https://www.youtube.com/watch?v=AV2vr5X7Re8" target="_blank" rel="noopener noreferrer">Youtube ansehen <EuiIcon type="popout" /></OutboundLink></p>
                </EuiText>
              }
            />
          </EuiFlexItem>
        </EuiFlexGroup>
    </React.Fragment>
  );
}